import { render, staticRenderFns } from "./qyInfo.vue?vue&type=template&id=61849d06&scoped=true"
import script from "./qyInfo.vue?vue&type=script&lang=js"
export * from "./qyInfo.vue?vue&type=script&lang=js"
import style0 from "./qyInfo.vue?vue&type=style&index=0&id=61849d06&prod&lang=scss"
import style1 from "./qyInfo.vue?vue&type=style&index=1&id=61849d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61849d06",
  null
  
)

export default component.exports